const ProposalSolveAmountForEnum = Object.freeze({
    APPLICATION_AMOUNT: 'APPLICATION_AMOUNT',
    CLEARED_FUNDS: 'CLEARED_FUNDS'
});

export default ProposalSolveAmountForEnum;
